/* @flow */

export default class FinalizeSubscriptionRequest {
  companyId: number;

  constructor (companyId: number) {
    this.companyId = companyId;
  }
}
